/**
 * ViewToggleGroup Component
 *
 * Toggle group for switching between different view modes.
 */

import type { ReactNode } from 'react';
import clsx from 'clsx';

export interface ViewToggleOption {
  value: string;
  icon: ReactNode;
  label: string;
}

export interface ViewToggleGroupProps {
  options: ViewToggleOption[];
  value: string;
  onChange: (value: string) => void;
  size?: 'sm' | 'md';
}

export function ViewToggleGroup({ options, value, onChange, size = 'md' }: ViewToggleGroupProps) {
  return (
    <div className="flex items-center gap-0.5 p-0.5 bg-surface-tertiary/50 rounded-lg">
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={clsx(
            'flex items-center gap-1.5 rounded-md font-medium transition-all',
            size === 'sm' ? 'px-2 py-1 text-[10px]' : 'px-2.5 py-1.5 text-[11px]',
            value === option.value
              ? 'bg-surface-primary text-text-primary shadow-sm'
              : 'text-text-tertiary hover:text-text-secondary hover:bg-surface-hover/50'
          )}
        >
          {option.icon}
          <span className="hidden sm:inline">{option.label}</span>
        </button>
      ))}
    </div>
  );
}
